<template>
  <div class="printerCard">
    <div class="cardContainer" @click="handleItem(info)">
      <!-- :style="{ height: !info.printeTask && info.update == '1' ? '200px' : '' }" -->
      <div class="conLeft">
        <img class="leftImg" :src="info.img" />
      </div>
      <div class="conRight">
        <div class="pName">
          <div class="nameLeft">
            <div class="name" :title="info.name">{{ info.name }}</div>
            <!-- <img src="@/assets/imgs/signal-one.png" />
            <img src="@/assets/imgs/signal-two.png" v-show="false" />
            <img src="@/assets/imgs/signal-three.png" v-show="false" /> -->
          </div>
          <div class="nameRight"></div>
        </div>
        <div class="labels">
          <div
            :class="
              $common.formatterStatus(info.device_status, info.is_printing) ==
              'Busy'
                ? 'busy'
                : $common.formatterStatus(
                    info.device_status,
                    info.is_printing
                  ) == 'Free'
                ? 'free'
                : 'offline'
            "
          >
            {{
              $t($common.formatterStatus(info.device_status, info.is_printing))
            }}
          </div>
        </div>
        <div class="pModel">
          <span class="label">{{ $t("MachineModel") }}</span>
          <span class="val">{{ info.model }}</span>
        </div>
        <div class="pCn">
          <span class="label">{{ $t("CNCode") }}</span>
          <span class="val">{{ info.base.description }}</span>
        </div>
        <div class="pFirmware">
          <div class="left">
            <span class="label">{{ $t("FirmwareVersion") }}</span>
            <span
              class="val"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>{{ info.version.firmware_version }}</div>
            </span>
          </div>
          <!-- <div class="right" @click="help(info.help_url)">
            <img src="@/assets/imgs/square.png" />
            <span>{{ $t("OfficialWiki") }}</span>
          </div> -->
        </div>
        <div class="more" v-if="isOnline">
          <el-popover
            placement="bottom"
            width="146"
            trigger="click"
            :append-to-body="false"
            @click.native="handlePopoverClick"
          >
            <div class="operate">
              <div class="item" @click.stop="handleRename">
                {{ $t("Rename") }}
              </div>
              <div class="item" @click.stop="handleMore">
                {{ $t("MoreInfo") }}
              </div>
              <div
                class="item"
                @click.stop="handleUpdate"
                :class="deviceOnline ? '' : 'noAllow'"
              >
                {{ $t("FirmwareVersion") }}
              </div>
              <div
                class="item"
                style="color: var(--warn-text-color)"
                @click.stop="deletePrinter"
              >
                {{ $t("delete") }}
              </div>
            </div>
            <span slot="reference"
              ><img class="more-icon" :src="getDarkIcon('more')"
            /></span>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="task" v-if="info && info.project">
      <div class="taskInfo">
        <div class="infoLeft">
          {{ formmatLabel(info?.project.print_status) }}
        </div>
        <div class="infoRight">
          <span class="layer"
            >{{ info?.project.curr_layer }}/{{
              info?.project.total_layers
            }}</span
          >
          <span class="time">{{
            $common.formatSeconds(parseInt(info?.project.remain_time) * 60)
          }}</span>
        </div>
      </div>
      <div class="taskProgress">
        <div class="progress">
          <div
            class="fill"
            :style="{ width: `${info.project.progress}%` }"
          ></div>
        </div>
      </div>
      <div class="consumeInfo">
        <div class="infoLeft">{{ info.project.progress }}%</div>
        <div
          class="infoRight"
          v-if="
            isOnline &&
            deviceOnline &&
            (info?.project.print_status == 1 || info?.project.print_status == 6)
          "
        >
          <div class="rightOp">
            <div
              class="opBox"
              v-if="getShow"
              @click="openInfo"
              :style="{
                opacity:
                  info.project.pause == '2' || info.project.pause == '4'
                    ? '.4'
                    : '1',
              }"
            >
              <img src="../../../assets/imgs/skip.svg" />
              <span class="label" style="color: #3986ff">{{ $t("skip") }}</span>
            </div>
          </div>
          <!-- <div class="rightOp">
            <div class="opBox" @click="handleSkipOp()">
              <img src="@/assets/imgs/icon-skip.png" />
              <span class="label" style="color: #438dff">{{ $t("Skip") }}</span>
              <span class="label" style="color: #438dff">(1)</span>
            </div>
          </div> -->
          <div class="rightOp">
            <div
              class="opBox"
              v-if="info.project.pause == '0'"
              @click.stop="handleOp('1')"
            >
              <img src="@/assets/imgs/icon-suspend.png" />
              <span class="label" style="color: #3986ff">{{
                $t("Pause")
              }}</span>
            </div>
            <div
              class="opBox"
              v-if="info.project.pause == '2' || info.project.pause == '4'"
            >
              <img src="@/assets/imgs/icon-pausing.png" />
              <span class="label" style="color: rgba(57, 134, 255, 0.4)">{{
                $t("Pause")
              }}</span>
            </div>
            <div
              class="opBox"
              v-if="info.project.pause == '1'"
              @click.stop="handleOp('2')"
            >
              <img src="@/assets/imgs/icon-continue.png" />
              <span class="label" style="color: #3986ff">{{
                $t("Resume")
              }}</span>
            </div>
            <div class="opBox" v-if="info.project.pause == '3'">
              <img src="@/assets/imgs/icon-continuing.png" />
              <span class="label" style="color: rgba(57, 134, 255, 0.4)">{{
                $t("Resume")
              }}</span>
            </div>
          </div>
          <div class="rightOver">
            <div
              class="opBox"
              v-if="info.project.pause == '0' || info.project.pause == '1'"
              @click.stop="handleOp('3')"
            >
              <img src="@/assets/imgs/icon-stop.png" />
              <span class="label" style="color: #ff4d4f">{{ $t("Stop") }}</span>
            </div>
            <div
              class="opBox"
              v-if="
                info.project.pause == '2' ||
                info.project.pause == '3' ||
                info.project.pause == '4'
              "
            >
              <img src="@/assets/imgs/icon-stoping.png" />
              <span class="label" style="color: rgba(255, 77, 79, 0.4)">{{
                $t("Stop")
              }}</span>
            </div>
          </div>
        </div>
        <div class="infoRight" v-else>
          <div class="rightOp">
            <div class="opBox">
              <img src="@/assets/imgs/icon-pausing.png" />
              <span class="label" style="color: rgba(57, 134, 255, 0.4)">{{
                $t("Pause")
              }}</span>
            </div>
          </div>
          <div class="rightOver">
            <div class="opBox">
              <img src="@/assets/imgs/icon-stoping.png" />
              <span class="label" style="color: rgba(255, 77, 79, 0.4)">{{
                $t("Stop")
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="cardFooter"
      v-if="
        info &&
        !info.project &&
        (formmatUpdate() == '1' || formmatUpdate() == '2') &&
        isOnline &&
        deviceOnline
      "
      @click.stop="handleUpdate"
    >
      <span>{{
        formmatUpdate() == "1"
          ? $t("NewFirmwareAvailable")
          : $t("FirmwareUpdating")
      }}</span>
    </div>
    <rename
      :visible.sync="renameVisible"
      :rename="info.name"
      @changeName="changeName"
    ></rename>
    <moreInfo :visible.sync="moreVisible" :id="info.id"></moreInfo>
    <firmwareUpdate :visible.sync="updateVisible" :info="info"></firmwareUpdate>
  </div>
</template>

<script>
// 这里导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import rename from "@/views/components/dialog/rename.vue";
import moreInfo from "@/views/components/dialog/moreInfo.vue";
import firmwareUpdate from "@/views/components/dialog/firmwareUpdate.vue";
import { mapActions } from "vuex";
import {
  unsetprinters,
  rename as renameApi,
  postSendOrder,
  getInfo,
  getPrinterFileDetails,
} from "@/api/network/printer.js";
export default {
  name: "printerItem",
  // 引入的组件需要注入到对象中
  components: {
    rename,
    moreInfo,
    firmwareUpdate,
  },
  // 定义props属性
  props: {
    printerInfo: Object,
  },
  // 数据层
  data() {
    return {
      info: {},
      moreVisible: false,
      updateVisible: false,
      renameVisible: false,
      skipVisible: false,
      //  定时器(广域网请求服务)
      setTimoutSkip: null,
      skipObj: null,
      httpSkipNum: 0
    };
  },
  computed: {
    prinProject() {
      return this.info?.project;
    },
    isOnline() {
      // 网络状态
      return this.$store.getters.GET_ISONLINE;
    },
    deviceOnline() {
      return this.info?.device_status != 2;
    },
    // 判断暗色图标
    getDarkIcon() {
      return (str) => {
        return this.$store.getters.GET_IS_DARK
          ? require(`@/assets/dark/${str}.webp`)
          : require(`@/assets/imgs/${str}.png`);
      };
    },
    getShow() {
      return (
        this.skipObj?.file_support_skip &&
        this.skipObj?.firmware_support_skip &&
        this.skipObj?.objects_skip_parts?.length > 1
      );
    },
  },
  watch: {
    "info.project": {
      handler: function (val) {
        if (!val) return;
        const status = val?.print_status;
        const arr = [1, 2, 5, 6, 9, 10, 11, 12];
        if (arr.includes(status)) {
          if (!this.skipObj) {
            this.getModelSkip();
          }
        } else {
          this.skipObj = null;
          this.httpSkipNum = 0
          clearTimeout(this.setTimoutSkip);
        }
        // console.log('info.project', val)
        // console.log('info', this.info)
      },
      immediate: true,
      deep: true,
    },
    printerInfo: {
      handler: function (val) {
        this.info = Object.assign({}, val);
      },
      immediate: true,
      deep: true,
    },
    prinProject: {
      deep: true,
      handler(newval, oldval) {
        if (newval && !oldval) {
          if (this.printerType == "cloud") {
            getInfo({ id: this.info.id }).then((res) => {
              if (res.code == 1) {
                let List = this.$store.getters.GET_CLOUD_PRINTER_LIST;
                let index = List.findIndex((item) => item.id == this.info.id);
                if (index != -1) {
                  List.splice(index, 1, { ...res.data });
                  this.$store.commit("SET_CLOUD_PRINTER_LIST", List);
                }
              }
            });
          }
        }
      },
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  updated() {
    // 生命周期 - 更新之后
  },
  destroyed() {
    // 生命周期 - 销毁完成
  },
  // 方法
  methods: {
    ...mapActions(["SET_LOADING_TRUE", "SET_LOADING_FALSE"]),
    //  跳转对应机器详情并打开跳过弹框
    openInfo() {
      if (this.info?.project?.pause == "2" || this.info?.project?.pause == "4")
        return;
      this.$store.commit("SET_SUBSCRIBE", true);
      this.$store.commit("SET_PRINTER_TYPE", "cloud");
      sessionStorage.setItem("skipObj", JSON.stringify(this.skipObj));
      this.$router.push({
        path: "/workbench",
        query: { id: this.info?.id, key: this.info?.key },
      });
    },
    getModelSkip() {
      const obj = this.$store.getters["GET_CLOUD_SKIP_OBJ"];
      const key = this.info?.key;
      const taskId = this.info?.project?.task_id;
      if (obj[key]) {
        if (obj[key][taskId]?.objects_skip_parts) {
          this.skipObj = obj[key][taskId];
        } else {
          obj[key] = {};
          obj[key][taskId] = {};
          this.getPrinterFileDetails();
        }
      } else {
        obj[key] = {};
        obj[key][taskId] = {};
        this.getPrinterFileDetails();
      }
      // this.getPrinterFileDetails();
    },
    //  服务端通过机器返回获取零件跳过信息
    async getPrinterFileDetails () {
      if (this.httpSkipNum > 5) return
      this.httpSkipNum++
      // type_function_ids含有48则表示该机器有支持零件跳过功能
      const arr = this.info?.type_function_ids || [];
      const { id } = this.info || {};
      const taskid = this.info?.project?.task_id;

      const obj = this.$store.getters["GET_CLOUD_SKIP_OBJ"];
      const key = this.info?.key;

      if (!arr.includes(48)) return;
      const res = await getPrinterFileDetails({
        printer_id: id,
        taskid,
      });
      const { code, data } = res;
      if (code == 1008) {
        this.setTimoutSkip = setTimeout(() => {
          this.getPrinterFileDetails();
        }, 1500);
        return;
      }
      this.httpSkipNum = 0
      obj[key] = obj[key] || {};
      obj[key][taskid] = data;
      this.$store.commit("SET_PRINTER_FILE_DETAILS", data);
      this.skipObj = data;
    },
    help(url) {},
    handleItem(item) {
      this.$store.commit("SET_PRINTER_TYPE", "cloud");
      this.$router.push({
        path: "/workbench",
        query: { id: item.id, key: item.key },
      });
    },
    handlePopoverClick(event) {
      // 阻止事件冒泡
      event.stopPropagation();
    },
    formmatUpdate() {
      // 处理update
      let update = undefined;
      if (this.info.multi_color_box) {
        // 如果接了多色盒子
        let boxUpdate = 0;
        this.info.multi_color_box_version.forEach((item) => {
          if (item.need_update > boxUpdate) {
            boxUpdate = item.need_update;
          }
        });
        if (this.info?.version?.need_update > boxUpdate) {
          update = this.info?.version?.need_update;
        } else {
          update = boxUpdate;
        }
      } else {
        update = this.info?.version?.need_update;
      }

      return update;
    },
    handleSkipOp() {},
    handleOp(val) {
      if (val == "3") {
        this.$confirm(this.$t("confirm_end_task"), this.$t("tips"), {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("Cancel"),
          type: "warning",
          center: true,
          customClass: this.$store.getters.GET_IS_DARK ? "dark-model" : "",
        })
          .then(() => {
            this.$store.dispatch("SET_LOADING_TRUE");
            // 结束
            postSendOrder({
              order_id: "4",
              project_id: this.info.project?.task_id + "",
              printer_id: this.info?.id + "",
              data: {
                taskid: this.info.project?.task_id + "",
              },
            }).catch(() => {
              this.$store.dispatch("SET_LOADING_FALSE");
            });
          })
          .catch(() => {
            // this.$message.info("已取消删除!");
          });
      } else if (val == "1") {
        this.$store.dispatch("SET_LOADING_TRUE");
        // 暂停
        postSendOrder({
          order_id: "2",
          project_id: this.info.project?.task_id + "",
          printer_id: this.info?.id + "",
          data: {
            taskid: this.info.project?.task_id + "",
          },
        }).catch(() => {
          this.$store.dispatch("SET_LOADING_FALSE");
        });
      } else if (val == "2") {
        this.$store.dispatch("SET_LOADING_TRUE");
        // 继续
        postSendOrder({
          order_id: "3",
          project_id: this.info.project?.task_id + "",
          printer_id: this.info?.id + "",
          data: {
            taskid: this.info.project?.task_id + "",
          },
        }).catch(() => {
          this.$store.dispatch("SET_LOADING_FALSE");
        });
      }
    },
    formmatLabel(val) {
      let map = {
        1: this.$t("printing"),
        2: this.$t("print_completed"),
        3: this.$t("print_failed"),
        4: this.$t("downloading"),
        5: this.$t("checking"),
        6: this.$t("preheating"),
        7: this.$t("slicing"),
        9: this.$t("auto_leveling"),
        10: this.$t("vibrating"),
        11: this.$t("flow_calibrating"),
        12: this.$t("drying_in_progress"),
      };
      return map[val];
    },
    deletePrinter() {
      this.$confirm(this.$t("confirm_delete_printer"), this.$t("tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("Cancel"),
        type: "warning",
        center: true,
        customClass: this.$store.getters.GET_IS_DARK ? "dark-model" : "",
      })
        .then(() => {
          unsetprinters({ id: this.info.id }).then((res) => {
            if (res.code == 1) {
              this.$message.success(this.$t("delete_successful"));
              //触发回调
              this.SET_LOADING_TRUE();
              this.$parent.$parent.getPrinters().then(() => {
                this.SET_LOADING_FALSE();
              });
            }
          });
        })
        .catch(() => {
          // this.$message.info("已取消删除!");
        });
    },
    changeName(name) {
      renameApi({ id: this.info.id, name: name }).then((res) => {
        if (res.code == 1) {
          let curPrinter = this.$store.getters.GET_CUR_PRINTER;
          if (curPrinter.id == this.info.id) {
            curPrinter.name = name;
            this.name = name;
            this.$store.dispatch("SET_CUR_PRINTER", curPrinter);
          }

          this.info.name = name;
          let List = this.$store.getters.GET_CLOUD_PRINTER_LIST;
          let index = List.findIndex((item) => item.id == this.info.id);
          if (index != -1) {
            List[index].name = name;
            this.$store.commit("SET_CLOUD_PRINTER_LIST", List);
          }
        }
      });
    },
    handleRename() {
      this.renameVisible = true;
    },
    handleMore() {
      this.moreVisible = true;
    },
    handleUpdate() {
      if (!this.deviceOnline) {
        return;
      }
      this.updateVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
/* @import url(); 引入公共css类 */
.printerCard {
  width: 100%;
  height: 240px;
  background: var(--dialog-background-color);
  border-radius: 0px 0px 0px 0px;
  display: flex;
  flex-direction: column;

  .cardContainer {
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 16px 0px 24px;
    display: flex;

    .conLeft {
      margin-right: 24px;

      .leftImg {
        width: 100px;
        height: 100px;
        object-fit: cover;
        border-radius: 0px 0px 0px 0px;
      }
    }

    .conRight {
      flex: 1;
      position: relative;
      width: 0;

      .pName {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        width: 100%;

        .nameLeft {
          display: flex;
          align-items: center;
          width: 100%;

          .name {
            height: 20px;
            font-family: AlibabaPuHuiTi-3-65-Medium;
            font-weight: normal;
            font-size: 14px;
            color: var(--three-text-color);
            line-height: 20px;
            margin-right: 8px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 80%;
          }
        }

        .nameRight {
        }
      }

      .labels {
        display: flex;
        margin-bottom: 8px;

        .lanInfo {
          display: flex;
          align-items: center;
          padding: 1px 4px;
          height: 19px;
          background: rgba(67, 141, 255, 0.16);
          border-radius: 4px 4px 4px 4px;
          margin-left: 8px;

          img {
            width: 17px;
            height: 17px;
          }

          span {
            font-weight: normal;
            font-size: 12px;
            color: var(--VI-color);
            line-height: 17px;
          }
        }
      }

      .pModel {
        display: flex;
        align-items: center;
        margin-bottom: 2px;

        .label {
          // width: 72px;
          height: 22px;

          font-weight: normal;
          font-size: 13px;
          color: var(--first-text-color);
          line-height: 22px;
          margin-right: 16px;
        }

        .val {
          // width: 252px;
          height: 22px;

          font-weight: normal;
          font-size: 13px;
          color: var(--three-text-color);
          line-height: 22px;
        }
      }

      .pCn {
        display: flex;
        align-items: center;
        margin-bottom: 2px;

        .label {
          // width: 72px;
          height: 22px;

          font-weight: normal;
          font-size: 13px;
          color: var(--first-text-color);
          line-height: 22px;
          margin-right: 16px;
        }

        .val {
          // width: 252px;
          height: 22px;

          font-weight: normal;
          font-size: 13px;
          color: var(--three-text-color);
          line-height: 22px;
        }
      }

      .pFirmware {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        .left {
          display: flex;
          align-items: center;

          .label {
            // width: 72px;
            height: 22px;

            font-weight: normal;
            font-size: 13px;
            color: var(--first-text-color);
            line-height: 22px;
            margin-right: 16px;
          }

          .val {
            // width: 252px;
            height: 22px;

            font-weight: normal;
            font-size: 13px;
            color: var(--three-text-color);
            line-height: 22px;
          }
        }

        .right {
          display: flex;
          align-items: center;

          img {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }

          span {
            height: 18px;

            font-weight: normal;
            font-size: 13px;
            color: var(--VI-color);
            line-height: 18px;
          }
        }
      }

      .more {
        position: absolute;
        top: 0px;
        right: 8px;

        img {
          width: 36px;
          height: 36px;
          cursor: pointer;
        }

        .operate {
          // width: 146px;
          background: var(--dialog-background-color);
          // box-shadow: 1px 1px 0px 0px #2D2D31;
          border-radius: 0px 0px 0px 0px;

          // border: 1px solid #DBDBDB;
          .item {
            width: 100%;
            height: 28px;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid transparent;
            font-weight: normal;
            font-size: 13px;
            color: var(--first-text-color);
            line-height: 28px;
            padding: 0 10px;
            box-sizing: border-box;
            cursor: pointer;
            white-space: nowrap;
            /* 确保文本在一行内显示 */
            overflow: hidden;
            /* 隐藏溢出的内容 */
            text-overflow: ellipsis;

            /* 使用省略号表示文本溢出 */
            &:hover {
              // background: rgba(67, 141, 255, 0.24);
              border-radius: 0px 0px 0px 0px;
              border: 1px solid var(--VI-color);
            }
          }

          .noAllow {
            opacity: 0.4;
            cursor: not-allowed;
          }
        }

        :deep(.el-popover) {
          padding: 0px;
          margin-top: 0px;
          border: 1px solid var(--input-border-color);
        }
      }
    }
  }

  .task {
    width: calc(100% - 16px);
    box-sizing: border-box;
    margin: 0px 8px 8px 8px;
    padding: 5px 20px;
    display: flex;
    flex-direction: column;
    background: var(--print-setting-background-color);
    border-radius: 4px 4px 4px 4px;
    height: 74px;

    .taskInfo {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;

      .infoLeft {
        height: 24px;
        line-height: 24px;

        font-weight: normal;
        font-size: 13px;
        color: var(--VI-color);
      }

      .infoRight {
        margin-right: 8px;

        .layer {
          height: 24px;

          font-weight: normal;
          font-size: 13px;
          color: var(--three-text-color);
          line-height: 24px;
          margin-right: 8px;
        }

        .time {
          height: 24px;

          font-weight: normal;
          font-size: 13px;
          color: var(--first-text-color);
          line-height: 24px;
        }
      }
    }

    .taskProgress {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 4px;

      .progress {
        width: 100%;
        height: 8px;
        background: var(--workbench-base-color);
        border-radius: 4px 4px 4px 4px;
        // background: #3986FF;
        // border:1px solid #3986FF;
        box-sizing: border-box;
        overflow: hidden;

        .fill {
          height: 8px;
          background: var(--VI-color);
        }
      }
    }

    .consumeInfo {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;

      .infoLeft {
        height: 24px;
        line-height: 24px;

        font-weight: normal;
        font-size: 14px;
        color: var(--VI-color);
      }

      .infoRight {
        display: flex;
        align-items: center;
        height: 24px;

        .rightOp {
          display: flex;
          align-items: center;
          padding: 1px 8px;
          margin-right: 8px;
          cursor: pointer;

          .opBox {
            display: flex;
            align-items: center;
            width: 100%;

            img {
              width: 14px;
              height: 14px;
              margin-right: 8px;
            }

            span {
              height: 22px;

              font-weight: normal;
              font-size: 14px;
              color: var(--VI-color);
              line-height: 22px;
            }
          }
        }

        .rightOver {
          display: flex;
          align-items: center;
          padding: 1px 8px;
          cursor: pointer;

          .opBox {
            display: flex;
            align-items: center;
            width: 100%;

            img {
              width: 14px;
              height: 14px;
              margin-right: 8px;
            }

            span {
              height: 22px;

              font-weight: normal;
              font-size: 14px;
              color: var(--VI-color);
              line-height: 22px;
            }
          }
        }
      }
    }
  }

  .cardFooter {
    width: calc(100% - 48px);
    height: 40px;
    box-sizing: content-box;
    margin: 0 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid var(--input-border-color);
    cursor: pointer;

    span {
      height: 22px;

      font-weight: normal;
      font-size: 14px;
      color: var(--VI-color);
      line-height: 22px;
    }
  }
}

.more-icon:active {
  background-color: rgba(67, 141, 255, 0.16);
  border-radius: 6px 6px 6px 6px;
  border: 1px solid var(--VI-color);
}
</style>
